import { listProviders, createProvider } from '../lib/db/providers';

export class ProvidersAPI {
  static async list() {
    const result = await listProviders();
    if (!result.success) {
      return { success: false, error: result.error };
    }
    return { success: true, data: result.data };
  }

  static async create(name: string) {
    const result = await createProvider(name);
    if (!result.success) {
      return { success: false, error: result.error };
    }
    return { success: true, data: result.data };
  }
}

